import React from 'react';
import { ArrowRight, Award, Clock, Shield } from 'lucide-react';
import { Button } from './ui/button';

const HeroSection = () => {
  const scrollToSection = (sectionId) => {
    const element = document.querySelector(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1468787737698-f5c03f0570dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHx0aGVybWFsJTIwcG93ZXIlMjBwbGFudHxlbnwwfHx8fDE3NjQ4NTU3NzF8MA&ixlib=rb-4.1.0&q=85"
          alt="Power Plant"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 via-slate-900/85 to-slate-900/70"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-8 relative z-10">
        <div className="max-w-4xl">
          <div className="mb-4 inline-flex items-center px-3 py-1.5 bg-blue-600/20 backdrop-blur-sm border border-blue-400/30 rounded-full">
            <Award className="w-3 h-3 sm:w-4 sm:h-4 mr-2 text-blue-400" />
            <span className="text-xs sm:text-sm text-blue-100">ISO 9001:2008 Certified | Since 1988</span>
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight">
            Excellence in Power Plant
            <span className="block text-blue-400">Engineering</span>
          </h1>

          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-slate-300 mb-6 sm:mb-8 max-w-2xl">
            Specializing in mechanical erection, renovation, and retrofitting of thermal and nuclear power plants across India.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mb-8 sm:mb-12">
            <Button
              size="lg"
              className="bg-blue-600 hover:bg-blue-700 text-white text-base sm:text-lg px-6 sm:px-8 py-4 sm:py-6 group w-full sm:w-auto"
              onClick={() => scrollToSection('#contact')}
            >
              Start Your Project
              <ArrowRight className="ml-2 w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-slate-900 text-base sm:text-lg px-6 sm:px-8 py-4 sm:py-6 w-full sm:w-auto"
              onClick={() => scrollToSection('#services')}
            >
              Our Services
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 max-w-3xl">
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-4 sm:p-6">
              <div className="flex items-center mb-2">
                <Clock className="w-4 h-4 sm:w-5 sm:h-5 text-blue-400 mr-2" />
                <span className="text-2xl sm:text-3xl font-bold text-white">35+</span>
              </div>
              <p className="text-slate-300 text-xs sm:text-sm">Years of Excellence</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-4 sm:p-6">
              <div className="flex items-center mb-2">
                <Award className="w-4 h-4 sm:w-5 sm:h-5 text-blue-400 mr-2" />
                <span className="text-2xl sm:text-3xl font-bold text-white">500</span>
              </div>
              <p className="text-slate-300 text-xs sm:text-sm">MW Capacity Units</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-4 sm:p-6">
              <div className="flex items-center mb-2">
                <Shield className="w-4 h-4 sm:w-5 sm:h-5 text-blue-400 mr-2" />
                <span className="text-2xl sm:text-3xl font-bold text-white">Zero</span>
              </div>
              <p className="text-slate-300 text-xs sm:text-sm">Tolerance on Safety</p>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 hidden sm:flex">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white/50 rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
